import '../styles/Expedientes.css';


/*Icons*/
import Casco_icon from '../imagenes/icons/casco.gif';
import Exp_icon from '../imagenes/icons/tarea.gif';

function Expedientes(){
  const documentos = [
    {
      titulo: 'MEJORAMIENTO Y AMPLIACION DEL SERVICIO DE AGUA POTABLE Y DISPOSICION SANITARIA DE EXCRETAS EN LOS SECTORES: CALVARIO, CHULLO LOMA, CAHUITUNA, SAYAN QAQA Y QESHQAYOC DE LA COMUNIDAD CAMPESINA DE PARCCO VALLECITO DEL DISTRITO DE SANTO TOMAS - PROVINCIA DE CHUMBIVILCAS - DEPARTAMENTO DE CUSCO',
      icon: Exp_icon,
      nombre: 'Ver Expediente',
      url: 'https://www.myqnapcloud.com/smartshare/70148603k625p40u46t64xb2_2d0792942n0124p81u0vuvza82555ii3',
    },
    {
      titulo: 'MEJORAMIENTO Y AMPLIACION DEL SERVICIO DE AGUA POTABLE Y DISPOSICION SANITARIA DE EXCRETAS EN LOS SECTORES DE ISCAYCANCHA HIJAÑUMA, ANTUYO CENTRAL, QUISA QUISA, NUEVO FORTALECER Y MARJAYAQUI DE LA COMUNIDAD CAMPESINA DE ANTUYO DEL DISTRITO DE SANTO TOMAS - PROVINCIA DE CHUMBIVILCAS - DEPARTAMENTO DE CUSCO',
      icon: Exp_icon,
      nombre: 'Ver Expediente',
      url: 'https://www.myqnapcloud.com/smartshare/70148603k625p40u46t64xb2_12c7fh56m0mm24sq162w95148626eeih',
    },
    {
      titulo: 'MEJORAMIENTO Y AMPLIACION DEL SERVICIO DE AGUA POTABLE Y ELIMINACION SANITARIA DE EXCRETAS EN LOS SECTORES: LANGUIPAMPA, QUESCCAYOC, TUPE Y SACSAYHUAMAN CENTRAL DE LA COMUNIDAD CAMPESINA ANCHAYAQUE CONDES DEL DISTRITO DE SANTO TOMAS - PROVINCIAL DE CHUMBIVILCAS - DEPARTAMENTO DE CUSCO',
      icon: Exp_icon,
      nombre: 'Ver Expediente',
      url: 'https://www.myqnapcloud.com/smartshare/70148603k625p40u46t64xb2_d7055g8jn00q2501r38t60182970c541',
    },
    {
      titulo: 'MEJORAMIENTO DEL SERVICIO EDUCATIVO DE NIVEL PRIMARIO EN LA IE N° 56319 ROSA DE SANTA MARIA DE USCAMARCA DEL DISTRITO DE SANTO TOMAS - PROVINCIA DE CHUMBIVILCAS - DEPARTAMENTO DE CUSCO',
      icon: Exp_icon,
      nombre: 'Ver Expediente',
      url: 'https://www.myqnapcloud.com/smartshare/70148603k625p40u46t64xb2_081i3h7k01232502qv7w055c56b7417h',
    },
    {
      titulo: 'MEJORAMIENTO DEL CAMINO VECINAL CHAMACA - LIMAMAYO - CCACHU (L-23.28 KM) DISTRITO DE CHAMACA, PROVINCIA DE CHUMBIVILCAS',
      icon: Exp_icon,
      nombre: 'Ver Expediente',
      url: 'https://www.myqnapcloud.com/smartshare/70148603k625p40u46t64xb2_a4d8hk66km4721o3q862w09013b5558g',
    },
    {
      titulo: 'MEJORAMIENTO Y AMPLIACION DE LOS SERVICIOS DE AGUA POTABLE Y SANEAMIENTO EN LOS ANEXOS INCUTA, PICUTANI Y CUATRO ESQUINAS DE LA CC URINSAYA PICUTANI YAVINA Y CHILLIHUANI',
      icon: Exp_icon,
      nombre: 'Ver Expediente',
      url: 'https://www.myqnapcloud.com/smartshare/70148603k625p40u46t64xb2_79hd2kk24m46290tq39w10494a4ehgff',
    },
  ];
  return(
    <section className='expediente-section'>
      <div className='titulo-expediente'>
        <img src={Casco_icon} className='titulo-icon'></img>
        <h2>Expedientes de obras públicas</h2>
      </div>
      <p className='subtitulo'>Expedientes de obras públicas ejecutadas por la MPCH</p>
      <div className='expediente-grid'>
        {documentos.map((doc, index) => (
          <div className='expediente-card' key={index}>
            <img src={doc.icon} className='doc-icon'></img>
            <h3>{doc.titulo}</h3>
            <a
            href={doc.url}
            target="_blank"
            
            >
            {doc.nombre}
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Expedientes;